const { ReservationConstants } = require('arbitrip-common/client/constants');
const _ = require('lodash');

function isRequestActionable(ticket) {
	return (
		ticket.status !== ReservationConstants.REQUEST_STATUS.APPROVED &&
		ticket.status !== ReservationConstants.REQUEST_STATUS.REJECTED &&
		ticket.status !== ReservationConstants.REQUEST_STATUS.EXPIRED
	);
}

// RESERVATION_STATUS.REQUESTED is deliberately excluded here — do not re-add it.
// Approval does not book: approvedRequestReservation only reveals the reservation,
// marks the ticket APPROVED and sends the "approved" email; it never calls the
// supplier, and no later job books an approved ticket. isRequestActionable above then
// returns false for an APPROVED ticket, so every button disappears — approving a still
// `requested` reservation strands it: ticket closed, nothing booked, credit-line
// exposure still held.
// The original complaint (Book failing because the employee's own request held the cap)
// was a double-DEBIT problem, since fixed at the cause by the request -> booking hold
// transfer: a derived booking credits the request's DEBIT and takes its own. So for a
// `requested` reservation, Book (ticket.action_url) is both the correct button and a
// working one.
function isReservationAvailableToApprove(status) {
	return (
		status === ReservationConstants.RESERVATION_STATUS.APPROVED ||
		status === ReservationConstants.RESERVATION_STATUS.PENDING_SUPPORT ||
		status === ReservationConstants.RESERVATION_STATUS.PENDING ||
		status === ReservationConstants.RESERVATION_STATUS.CONFIRMED
	);
}

function getBreakfastIncluded(reservation) {
	return (
		_.get(reservation, 'deal.dca.heuristicOptions.includesBreakfast') ||
		_.get(reservation, 'deal.dca.heuristicOptions.isHalfBoard') ||
		_.get(reservation, 'deal.dca.heuristicOptions.isFullBoard') ||
		_.get(reservation, 'deal.dca.heuristicOptions.isAllInclusive')
	);
}

module.exports = {
	isRequestActionable,
	getBreakfastIncluded,
	isReservationAvailableToApprove,
};
